<template>
  <commonSelect
    :value="value"
    @input="v=>$emit('input',v)"
    :placeholder="placeholder"
    :clearable="clearable"
    idKey="PayId"
    labelKey="PayName"
    :get-data-func="getDataFunc"
  />
</template>
<script>
import commonSelect from "@/components/common/select";
export default {
  props: {
    value: {},
    clearable: {
      type: Boolean,
      default: true,
    },
    placeholder: {
      type: String,
      default: "请选择付款方式",
    },
  },
  components: { commonSelect },
  data() {
    return {
      api: require("@/api/ba/pay").default,
    };
  },
  methods: {
    getDataFunc(params) {
      return new Promise((resolve, reject) => {
        this.api.list({ Status: 1 }).then((res) => {
          resolve(res);
        });
      });
    },
  },
};
</script>

